import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { SelectDetailsOptions, SelectDetailsValue } from '../modal.model';

@Component({
  selector: 'sb-select-details-modal',
  templateUrl: './sb-select-details-modal.component.html',
  styleUrls: ['./sb-select-details-modal.component.scss'],
  standalone: false,
})
export class SbSelectDetailsModalComponent implements OnInit {
  options: SelectDetailsOptions<any>;
  @Input()
  templateId: string;
  selectedOption: SelectDetailsValue<any>;

  searchStr: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as SelectDetailsOptions<any>;
    this.selectedOption = this.options.initialValue;
  }

  constructor(private state: SbModalState) {}

  setSelectedOption<T>(selectedOption: SelectDetailsValue<T>) {
    this.selectedOption = selectedOption;
  }

  search($event) {
    this.searchStr = $event;
  }

  getClass<T>(option: SelectDetailsValue<T>) {
    if (this.selectedOption && this.selectedOption.value + '' === option.value + '') {
      return 'selected';
    }
    return '';
  }

  ok() {
    if (this.checkOkEnabled()) {
      this.state.modals.get(this.templateId).close({
        value: this.selectedOption,
        cancel: false,
      });
    }
  }

  checkOkEnabled() {
    return this.selectedOption !== null;
  }

  cancel() {
    this.state.modals.get(this.templateId).close({
      value: null,
      cancel: true,
    });
  }
}
